import { OneUpdateGroupDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useUpdateGroupActionResolver: OneCreationActionResolver = () => {
  const { navigation } = useNavigation()

  const [updateGroup, { loading }] = useMutation(OneUpdateGroupDocument, {
    extractorFn: (data) => data.postsMutations.updatePostsGroup,
    errorPolicy: 'all',
  })

  const updateGroupHandler = async (args: {
    groupId: string
    title?: string
    description?: string
    dynamicTeamId?: string
  }) => {
    const result = await updateGroup({
      variables: {
        id: args.groupId,
        title: args.title ?? undefined,
        description: args.description ?? undefined,
        dynamicTeamId: args.dynamicTeamId ?? undefined,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success && handled.data.group?.id) {
      const url =
        handled.data.group.frontendUrl ??
        navigation.communities.id.fullPath({ id: handled.data.group.id })

      return {
        to: url,
        data: args,
      }
    }

    return handled
  }

  return {
    resolver: updateGroupHandler,
    loading,
  }
}

export const UpdateGroupAction: OneCreateAction = {
  actionResolver: useUpdateGroupActionResolver,
  policies: [POSTS_POLICIES.postsManage],
}
